import ParameterValidator from '@mvps-genesis/parameter-validator';
import 'CookieConsent';

/*
 *------------------------------------------------------------------------------
 * Cookie Consent
 *------------------------------------------------------------------------------
 *
 * Class to enable creation and interaction with cookie consent functionality.
 *
 * This class currently utlizes the Cookie Consent JavaScript API library.
 * Documentation for the library can be referenced here:
 * https://www.osano.com/cookieconsent/documentation/javascript-api/
 */
export default class CookieConsent {

	/**
	 * Parameter Validator object
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * Class options object. See class constructor() for option definitions.
	 *
	 * @var Object
	 */
	options;

	/**
	 * Create a new CookieConsent object
	 *
	 * @param	Object	options	CookieConsent library configuration object (see library documentation link at top of file)
	 *
	 */
	constructor (options) {
		this.#validator = new ParameterValidator(this);
		this.options = this.#validator.isObject('options', options);

		window.cookieconsent.initialise(this.options);
	}
}
